export default class DaySpanUtils {

	static getRelativeSprintDate(sprint, offset) {
		var day = sprint.start.clone();
		if (offset.unit == '-w') {
			day.add(-offset.value).weeks();
		} else if (offset.unit == '-d') {
			day.add(-offset.value).days();
		} else if (offset.unit == 'd') {
			day.add(offset.value).days();
		} else if (offset.unit == 'w') {
			day.add(offset.value).weeks();
		}

		return day;
	}

	static readFormDaySpan($container, prefix) {
		var value = $container.find(prefix + '-value').val();
		var unit = $container.find(prefix + '-unit').val();

		if (!unit || unit == '0') {
			return {value: 0, unit: '0'};
		} else {
			return {value: parseInt(value, 10), unit: unit};
		}
	}

	static writeFormDaySpan($container, prefix, value) {
		$container.find(prefix + '-value').val(value.value);
		$container.find(prefix + '-unit').val(value.unit);
	}

}
